import React from 'react';
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UNameJobInfo from "ubs-framework/v2/UNameJobInfo";
import UAvatar from "ubs-framework/v2/UAvatar";
import {useDispatch, useSelector} from "react-redux";
import * as Icon from "ubs-icons";
import {COLOR, FORMAT} from "ubs-framework/v2/common/constant";
import UIcon from "ubs-framework/v2/UIcon";
import MembersFullNameList from "../../common/list/member-full-name-list";
import {getName, getThumbor} from "ubs-framework/v2/common/function";
import moment from "moment";
import {useHistory, useRouteMatch} from "react-router-dom";
import {REMINDER} from "../../../common/constant";

const ViewReminder = React.memo(() => {
    const DISPATCH = useDispatch();
    const history = useHistory();
    let match = useRouteMatch('/:orgId/reminder/:id')?.isExact;

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _R = useSelector(e => e?.reminder?.showReminder);
    const _ID = useSelector(e => e.common?._id);

    const onClose = () => {
        if(match) history.push(`/${_ORG_ID}/reminder`);
        DISPATCH({type: 'SHOW_REMINDER', payload: null})
    }

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={675}
                header={<h4>Reminder Details</h4>}
                onClose={() => onClose()}
            >
                <div className="u_p-15">
                    <div className="u_flex-align u_mb-25">
                        <div className="u_pr-15">
                            <UNameJobInfo
                                avatar={<UAvatar name={getName(_R)} image={_R?.profileImage?.url} width={54} thumbor={getThumbor('32x32')} s3Url={_S3_BASE_URL}/>}
                                name={getName(_R)}
                                job={_R?.location}
                            />
                        </div>
                        <div className="u_px-15 u_br-light u_bl-light">
                            <UNameJobInfo
                                name={"Apply For"}
                                job={_R?.jobTitle}
                            />
                        </div>
                        {/*<div className="u_pl-15">
                            <UNameJobInfo
                                name={"Applied/Added on"}
                                job={"Feb 16, 2022 09:13 am"}
                            />
                        </div>*/}
                    </div>
                    <div className="u_flex-align u_content-between u_mb-25">
                        <div className="u_pr-15">
                            <UNameJobInfo
                                avatar={<UIcon color="#007AFF" thumb={44} icon={<Icon.Calendar size={16} fill={COLOR.u_blue}/>}/>}
                                name={"Reminder Date"}
                                job={_R?.date ? moment(_R?.date).format(FORMAT.TICKET_DATE) : '-'}
                            />
                        </div>
                        <div className="u_px-15">
                            <UNameJobInfo
                                avatar={<UIcon color="#007AFF" thumb={44} icon={<Icon.Watch size={16} fill={COLOR.u_blue}/>}/>}
                                name={"Reminder Time"}
                                job={_R?.date ? moment(_R?.date).format(FORMAT.TIME) : '-'}
                            />
                        </div>
                        <div className="u_pl-15">
                            <p className="u_small-font u_task-darkname u_mb-3">Reminder to</p>
                            <div>
                                <MembersFullNameList members={_R?.reminderType === REMINDER.TYPE.ME ? [_ID] : _R?.to}/>
                            </div>
                        </div>
                    </div>
                    <div className="u_b-light u_p-10" style={{borderRadius: '5px'}}>
                        <h6 className="u_small-font u_task-darkname u_mb-10">Note:</h6>
                        <p className="u_small-font">{_R?.note}</p>
                    </div>
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default ViewReminder;
